import { Params, QueryFn } from ".";

export const getPerformanceTask: QueryFn = (params?: Params) => /* GraphQL */ `
  query ${params?.label || "GetPerformanceTask"}($input: ModelGetInput!) {
    getPerformanceTask(input: $input) {
      ${params?.fields || "id sk"}
    }
  }
`;

export const getPerformanceTaskStatic = /* GraphQL */ `
  query GetPerformanceTask($input: ModelGetInput!) {
    getPerformanceTask(input: $input) {
      id
      sk
      name
      workspaceId
      bankId
      createdAt
      updatedAt
      objectives {
        id
        objective {
          id
          sk
          content
          notes
          abbreviation
          parentId
          scope
          sequence
          annotations {
            content
            label
          }
        }
      }
      content {
        body
      }
      rubrics {
        rubric {
          id
          sk
          workspaceId
          content {
            rubric
          }
        }
      }
      resourcesIds {
        id
        sk
      }
    }
  }
`;

export const getWebDocument: QueryFn = (params?: Params) => /* GraphQL */ `
  query ${params?.label || "GetWebDocument"}($input: ModelGetInput!) {
    getWebDocument(input: $input) {
      ${params?.fields || "id sk"}
    }
  }
`;

export const getOpenGraphMetadata = /* GraphQL */ `
  query GetOpenGraphMetadata($input: ControllerInput!) {
    getOpenGraphMetadata(input: $input)
  }
`;
